import { RangeFilter } from '../../../shared/models/range.model';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { Serializable } from '@admin/core/models/serializable';
import { Specialization } from '@admin/shared/models/specializations.model';

export class JobseekerFilterModel
  implements Serializable<JobseekerFilterModel>
{
  fromObject(object: any): JobseekerFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      Keyword: this.keyWord,
      ProfileState: this.profileState,
      DrivingLicenses: this.drivingLicenses,
      Locations: this.locations,
      RegistrationDate:
        this.registrationDate && this.registrationDate.toObject(),
      LastVisitDate: this.lastVisitDate && this.lastVisitDate.toObject(),
      ProviderWebsite: this.providerWebsite,
      HasCV: this.hasCV,
      EventId: this.eventId,
      Email: this.email,
      PhoneNumber: this.phoneNumber,
      Categories: this.categories,
      SpecializationIdList: this.specializations,
      ModerationStatus: this.moderationStatus,
      IsInModeration: this.isInModeration,
      IsPending: this.isPending,
      ExtendedLocationList: this.extendedLocationList,
      IsUnemployed: this.isUnemployed,
      IsWihoutExperience: this.isWihoutExperience,
      OnlyInLastJobs: this.onlyInLastJobs,
      CustomerName: this.customerName,
      EducationalInstitutionIdList: this.educationalInstitutionIdList,
      EducationalProgramIdList: this.educationalProgramIdList,
      EducationLevelIdList: this.educationLevelIdList,
      LanguageIdList: this.languages,
      IsVehicleOwner: this.isVehicleOwner,
      HasDocument: this.hasDocument,
      TransportTypeIdList: this.vehicleTypes,
      DocumentTypes: this.documentTypes,
      ExperienceFrom: this.experienceFrom,
      ExperienceTo: this.experienceTo,
    };

    return result;
  }

  keyWord: string;
  profileState: number;
  drivingLicenses: number[];
  locations: number[];
  registrationDate: RangeFilter<Date>;
  lastVisitDate: RangeFilter<Date>;
  providerWebsite: number;
  hasCV: boolean;
  specializations: string[];
  eventId: number;
  email: string;
  phoneNumber: string;
  categories: number[];
  moderationStatus: string;
  isInModeration: boolean;
  isPending: boolean;
  extendedLocationList: string[];
  isUnemployed: boolean;
  isWihoutExperience: boolean;
  onlyInLastJobs: boolean;
  customerName: string;
  educationalInstitutionIdList: number[];
  educationalProgramIdList: number[];
  educationLevelIdList: number[];
  languages: number[];
  isVehicleOwner: boolean;
  hasDocument: boolean;
  vehicleTypes: number[];
  documentTypes: number[];
  experienceFrom: number;
  experienceTo: number;

  constructor() {
    this.drivingLicenses = [];
    this.locations = [];
    this.keyWord = null;
    this.profileState = null;
    this.lastVisitDate = new RangeFilter(null, null);
    this.registrationDate = new RangeFilter(null, null);
    this.providerWebsite = null;
    this.hasCV = null;
    this.eventId = null;
    this.email = null;
    this.phoneNumber = null;
    this.categories = [];
    this.moderationStatus = null;
    this.isInModeration = null;
    this.isPending = null;
    this.extendedLocationList = [];
    this.specializations = [];
    this.isUnemployed = null;
    this.isWihoutExperience = null;
    this.onlyInLastJobs = null;
    this.customerName = null;
    this.educationalInstitutionIdList = [];
    this.educationalProgramIdList = [];
    this.educationLevelIdList = [];
    this.languages = [];
    this.isVehicleOwner = null;
    this.hasDocument = null;
    this.vehicleTypes = [];
    this.documentTypes = [];
    this.experienceFrom = null;
    this.experienceTo = null;
  }
}
